import {useState} from 'react';
import moment from 'moment';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

import DateField from '../common/DateField';

const ClaimDataEditor = props => {
  const {date} = props;
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogContent>
          <DateField
            defaultValue={date ? new Date(date) : null}
            onChange={async e => {
              let value = e?.target?.value;
              if (value) {
                value = moment(value).toISOString();
                const response = await props.onChange({target: {value}});
                if (!response?.error) setIsOpen(false);
              }
            }}
            style={{width: '150px'}}
            format='MM/DD/YYYY'
          />
        </DialogContent>
      </Dialog>
      <Stack direction='row' spacing={1} alignItems='center'>
        { date ? moment(date).format('MM/DD/YYYY') : '' }
        <IconButton 
          color='primary'
          size='small'
          onClick={() => setIsOpen(true)}
        >
          <EditIcon sx={{fontSize: '1rem'}} />
        </IconButton>
      </Stack>
    </>
  );
};

export default ClaimDataEditor;